{
  "clear": "Notīrīt",
  "invalid": "(nederīgs)",
  "loading": "Notiek ielāde...",
  "noResults": "Nav rezultātu",
  "valid": "(derīgs)"
}
